/**
 * Debe coincidir con backend/src/utils/idealistaFotoKey.js (dedupe fotos Idealista).
 */
export function claveFotoIdealistaUrl(u) {
  if (!u || typeof u !== "string") return "";
  const s = u.replace(/\\u002f/gi, "/").trim();
  try {
    const x = new URL(s);
    const path = x.pathname.toLowerCase();
    const parts = path.split("/").filter(Boolean);
    if (!parts.length) return `${x.hostname.toLowerCase()}${path}`;

    const last = parts[parts.length - 1];
    if (!/\.(jpe?g|png|webp|avif)$/i.test(last)) {
      return `${x.hostname.toLowerCase()}${path}`;
    }

    const base = last.replace(/\.(jpe?g|png|webp|avif)$/i, "");
    if (/^\d{7,}([_-]\d+)?$/i.test(base)) return base.toLowerCase();
    if (/^[a-f0-9]{12,}$/i.test(base)) return base.toLowerCase();

    if (parts.length >= 2) {
      const folder = parts[parts.length - 2];
      return `${folder}/${last}`;
    }
    return `${x.hostname.toLowerCase()}${path}`;
  } catch {
    return String(s).slice(0, 240).toLowerCase();
  }
}
